/*
  Позвонить одному должнику - окно из карточки счёта (06.10.2026).

  Нажатие «Позвонить» сразу не звонит: окно сначала спрашивает у сервера разбор
  по этому счёту и говорит, можно ли сейчас, а если нет - почему. Звонок -
  внешнее действие, которое не отменить, и узнавать о запрете после набора
  поздно. Правила при самом заказе сервер проверяет ещё раз: окно - подсказка
  человеку, а не защита.
*/

import { useEffect, useState } from 'react'

import { api } from '../api/client.js'
import { Loading, Notice } from './Common.jsx'
import Modal from './Modal.jsx'

export default function CallDialog({ accountId, title, onClose }) {
  const [plan, setPlan] = useState(null)
  const [state, setState] = useState({ busy: false, done: false, error: null })

  useEffect(() => {
    api
      .planWave([accountId])
      .then(setPlan)
      .catch((error) => setState((now) => ({ ...now, error })))
  }, [accountId])

  async function call() {
    setState({ busy: true, done: false, error: null })
    try {
      await api.orderCall(accountId)
      setState({ busy: false, done: true, error: null })
    } catch (error) {
      setState({ busy: false, done: false, error })
    }
  }

  const allowed = plan?.planned?.[0]
  const refused = plan?.skipped?.[0]
  return (
    <Modal title={`Позвонить: ${title}`} onClose={onClose} busy={state.busy}>
      <div className="stack">
        {!plan && !state.error ? <Loading what="Проверяем, можно ли звонить" /> : null}
        {plan?.channel_blocked ? (
          <Notice kind="warn">
            <div className="notice__what">Звонить нечем.</div>
            <div className="notice__do">{plan.channel_blocked}</div>
          </Notice>
        ) : null}
        {refused ? (
          <Notice kind="warn">
            <div className="notice__what">Сейчас звонить нельзя.</div>
            <div className="notice__do">{refused.explanation}</div>
          </Notice>
        ) : null}
        {allowed && !state.done ? (
          <div className="stack">
            <div>
              {allowed.local_time
                ? `Местное время должника ${allowed.local_time.slice(11, 16)}, пределы частоты не исчерпаны.`
                : 'Пределы частоты не исчерпаны.'}
            </div>
            <div className="muted">
              Звонит голосовой агент от имени вашей организации. Итог и расшифровка появятся в
              «Последних обращениях» раздела «Коммуникации», запись разговора - на странице звонка.
            </div>
          </div>
        ) : null}
        {state.done ? (
          <Notice kind="ok">
            Звонок заказан: станция набирает номер. Чем он кончился, будет видно в «Последних
            обращениях» через минуту-другую.
          </Notice>
        ) : null}
        <Notice error={state.error} />
        <div className="row">
          {allowed && !state.done ? (
            <button type="button" className="button" disabled={state.busy} onClick={call}>
              {state.busy ? 'Заказываем звонок…' : 'Позвонить сейчас'}
            </button>
          ) : null}
          <button type="button" className="button button--quiet" onClick={onClose}>
            {allowed && !state.done ? 'Отмена' : 'Закрыть'}
          </button>
        </div>
      </div>
    </Modal>
  )
}
